import authSlice from "./auth-slice";
import loansSlice from "./loans-slice";
import deviceFinanceSlice from "./device-finance-slice";
import userSlice from "./user-slice";
import {documentReducer} from "./document-slice";
import corporateDirectorSlice from "./corporate-slice";
import vehicleFinanceSlice from "./vehicle-finance-slice";
import payLaterVendorSlice from "./pay-with-quickbucks-slice";

const reducers = {
  auth: authSlice,
  loans: loansSlice,
  deviceFinance: deviceFinanceSlice,
  vehicleFinance:vehicleFinanceSlice,
  payLaterVendor: payLaterVendorSlice,
  user: userSlice,
  document: documentReducer,
  corporate: corporateDirectorSlice,
};

export default reducers;